var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncCm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sync_ic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "005---Sync-ANF---Select-Target-Volume",
    transform: "translate(-109.000000, -214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wizard",
    transform: "translate(0.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-cloud-sync",
    transform: "translate(110.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-cloud-sync-(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sync_ic"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#1AA6FF",
    strokeWidth: 1.11111111,
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.833333, 10.833333)",
    fill: "#1AA6FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1333333,8.3 C16.6558333,8.3 16.2666667,8.68916667 16.2666667,9.16666667 C16.2666667,12.9883333 13.155,16.1 9.33333333,16.1 C7.49403808,16.103595 5.729695,15.3714526 4.43333333,14.0666667 L5.4875,12.9783333 C5.58690619,12.8793035 5.6166232,12.7300252 5.5627205,12.600476 C5.5088178,12.4709267 5.38198057,12.3867873 5.24166667,12.3875 L1.88166667,12.6291667 C1.78907011,12.6289435 1.7002139,12.6656858 1.63481633,12.7312398 C1.56941876,12.7967938 1.53288896,12.8857376 1.53332933,12.9783333 L1.71833333,16.3066667 C1.71833333,16.6175 2.09083333,16.7708333 2.30916667,16.5525 L3.20166667,15.2916667 C4.82577045,16.9212726 7.03261141,17.8360409 9.33333333,17.8333393 C14.1133333,17.8333393 18,13.9466667 18,9.16666667 C18,8.68916667 17.6108333,8.3 17.1333333,8.3 L17.1333333,8.3 Z M2.4,9.16666667 C2.4,5.345 5.51166667,2.23333333 9.33333333,2.23333333 C11.1791667,2.23333333 12.9333333,2.97416667 14.23,4.27 L13.2425,5.46083333 C13.1436929,5.55994225 13.1143568,5.70883135 13.168183,5.83801404 C13.2220091,5.96719673 13.3483859,6.05120547 13.4883333,6.05083333 L16.8191667,6.05083333 C17.0108333,6.05083333 17.1675,5.8975 17.1675,5.7025 L17.1366667,2.0175 C17.1370388,1.87755258 17.0530301,1.75117575 16.9238474,1.69734963 C16.7946647,1.64352351 16.6457756,1.67285957 16.5466667,1.77166667 L15.4583333,3.045 C13.83386,1.41961287 11.6313275,0.50443813 9.33333333,0.5 C4.55333333,0.5 0.666666667,4.38666667 0.666666667,9.16666667 C0.666666667,9.64416667 1.05583333,10.0333333 1.53333333,10.0333333 C2.01083333,10.0333333 2.4,9.64416667 2.4,9.16666667 L2.4,9.16666667 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncCm);
export default __webpack_public_path__ + "static/media/sync-cm.63f87f033737b4d90cd4332f2912b2ee.svg";
export { ForwardRef as ReactComponent };